import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CsPage, NavController } from 'providers/nav-controller';
import { AuthRole } from '@cf-shared/couch-auth';
import { AuthService } from 'services/auth.service';

interface TestNavigationChildPageParams {
  mode?: string;
  filter?: string;
  debug?: string;
}

@Component({
    selector: 'page-test-navigation-child',
    templateUrl: 'test-navigation-child.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestNavigationChildPage extends CsPage<TestNavigationChildPageParams> {
  // URL param values
  modeValue: string = '';
  filterValue: string = '';
  debugValue: string = '';
  currentUrl: string = '';

  constructor(
    public navCtrl: NavController,
    protected auth: AuthService,
    private cd: ChangeDetectorRef
  ) {
    super();
  }

  async ionViewCanEnter() {
    await this.auth.pageAuthGuardAsync(AuthRole.Unknown);
  }

  async ionViewWillEnter() {
    // read params from navigation
    this.modeValue = this.navParams.data.mode || '';
    this.filterValue = this.navParams.data.filter || '';
    this.debugValue = this.navParams.data.debug || '';

    // update current URL display
    this.updateCurrentUrl();
    this.cd.markForCheck();
  }

  private updateCurrentUrl() {
    this.currentUrl = this.navCtrl.location.path();
  }

  // manual URL update - called when button is clicked
  async updateUrlParams() {
    // always provide all params for route parameters
    // use empty string as the value when param is empty (not undefined)
    const params: TestNavigationChildPageParams = {
      mode: this.modeValue || '',
      filter: this.filterValue || '',
      debug: this.debugValue || ''
    };

    // update URL with new params
    await this.navCtrl.updateCurrentPageParamsAsync(params);

    // update URL display
    this.updateCurrentUrl();
    this.cd.markForCheck();
  }

  // navigate back to parent
  async navigateBackToParent() {
    // when going back, the parent page should retain its params
    await this.navCtrl.popAsync();
  }
}
